import AccountHeader from '@components/profile/AccountHeader'
import CollectionItems from '@components/profile/CollectionItems'
import FractionItems from '@components/profile/FractionItems'
import ListedItems from '@components/profile/ListedItems'
import PoolsItems from '@components/profile/PoolsItems'
import PrivatePools from '@components/profile/PrivatePools'
import { ProfileCover } from '@components/profile/ProfileCover'
import { ClaimModal } from '@components/shared/modal/ClaimModal'
import { DefaultPageTemplate } from '@components/shared/templates/DefaultPageTemplate'
import { TokenTypeEnum } from '@graphql/variables/SharedVariable'
import { GetServerSideProps } from 'next'
import ProfileHeader from '../../../components/profile/ProfileHeader'

interface AccountPageProps {
  account: string
  tokenType: string
  chainId: number
}

export default function AccountPage({ account, tokenType, chainId }: AccountPageProps) {
  return (
    <DefaultPageTemplate header={<ProfileHeader account={account} chainId={chainId} />}>
      <ProfileCover account={account} />
      <AccountHeader account={account} />
      {tokenType === 'collection' && <CollectionItems account={account} network={chainId} />}
      {tokenType === 'listed' && <ListedItems account={account} network={chainId} />}
      {tokenType === 'fractions' && <FractionItems account={account} network={chainId} />}
      {tokenType === 'pools' && <PoolsItems account={account} network={chainId} />}
      {tokenType === 'privatePools' && <PrivatePools account={account} network={chainId} />}
      <ClaimModal />
    </DefaultPageTemplate>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  const account = context.params?.account
  const chainId = context.params?.chainId
  const { tokenType } = context.query

  if (!account) {
    return {
      notFound: true
    }
  }

  return {
    props: {
      account,
      chainId: Number(chainId) || 1,
      tokenType: tokenType || TokenTypeEnum.collection
    }
  }
}
